const _scaleSize = 1;
const _scaleFont = 1;

export function scaleSize(size: number): number {
  return size * _scaleSize;
}

export function scaleFont(fontSize: number): number {
  return Math.ceil(fontSize * _scaleFont);
}
